import { Injectable } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { TranslocoService } from '@ngneat/transloco';
import { switchMap } from 'rxjs/operators';

@Injectable()
export class TranslocoMatPaginatorIntl extends MatPaginatorIntl {
  constructor(private readonly transloco: TranslocoService) {
    super();

    // 1) Inicial
    const lang = this.transloco.getActiveLang();
    this.transloco.load(lang).subscribe(() => {
      this.applyTranslations();
      this.changes.next();
    });

    // 2) Cuando cambia el idioma: primero load(lang), luego traducir
    this.transloco.langChanges$
      .pipe(switchMap((newLang) => this.transloco.load(newLang)))
      .subscribe(() => {
        this.applyTranslations();
        this.changes.next();
      });
  }

  private applyTranslations(): void {
    this.itemsPerPageLabel = this.transloco.translate('paginator.itemsPerPage');
    this.nextPageLabel = this.transloco.translate('paginator.nextPage');
    this.previousPageLabel = this.transloco.translate('paginator.previousPage');
    this.firstPageLabel = this.transloco.translate('paginator.firstPage');
    this.lastPageLabel = this.transloco.translate('paginator.lastPage');
  }

  override getRangeLabel = (page: number, pageSize: number, length: number): string => {
    if (length === 0 || pageSize === 0) return `0 de ${length}`;
    const start = page * pageSize + 1;
    const end = Math.min((page + 1) * pageSize, length);
    return `${start} – ${end} de ${length}`;
  };
}
